import styled, { css } from "styled-components";

import { themeColors } from "js/react/sharedStyles";

const baseText = css`
    font-family: "Source Sans Pro";
    font-size: 15px;
    font-weight: 400;
    line-height: normal;
    text-transform: none;
    align-self: flex-start;
    color: #333;
`;

const headerText = css`
    font-size: 24px;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: 0.5px;
`;

const subHeaderText = css`
    font-size: 16px;
    font-weight: 400;
    line-height: 125%;
    letter-spacing: 0.5px;
`;

const descriptionText = css`
    font-size: 16px;
    font-weight: 600;
`;

const uppercaseLabelText = css`
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 600;
`;

const noteText = css`
    font-size: 12px;
    font-weight: 400;
    color: ${themeColors.mediumGray};
`;

const regularText = css`
    font-size: 13px;
    font-weight: 600;
`;

const smallText = css`
    font-size: 9px;
    color: ${themeColors.mediumGray};
`;

const popupLabelText = css`
    color: ${themeColors.mediumGray};
    font-size: 11px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 1px;
    text-transform: uppercase;
    text-align: right;
`;

const popupValueText = css`
    color: ${themeColors.darkGray};
    font-size: 16px;
    font-weight: 400;
    line-height: 125%;
`;

const popupDescriptionText = css`
    color: #333;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 19px; /* 158.333% */
    text-transform: uppercase; 
`;

const nonWrappingText = css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

interface TextContentProps {
    header?: boolean,
    subHeader?: boolean,
    description?: boolean,
    uppercase?: boolean,
    center?: boolean,
    note?: boolean,
    regular?: boolean,
    error?: boolean,
    bold?: boolean,
    italic?: boolean,
    color?: string,
    small?: boolean,
    dark?: boolean,
    light?: boolean,
    noWrap?: boolean,
    popupLabel?: boolean,
    popupValue?: boolean,
    popupDescription?: boolean,
}

export const TextContent = styled.span<TextContentProps>`
    ${baseText}

    ${props => props.header && headerText}
    ${props => props.subHeader && subHeaderText}
    ${props => props.description && descriptionText}
    ${props => props.uppercase && uppercaseLabelText}
    ${props => props.note && noteText}
    ${props => props.regular && regularText}
    ${props => props.small && smallText}
    ${props => props.popupLabel && popupLabelText}
    ${props => props.popupValue && popupValueText}
    ${props => props.popupDescription && popupDescriptionText}
    ${props => props.noWrap && nonWrappingText}

    ${props => props.color && css`color: ${props.color};`}
    ${props => props.dark && css`color: ${themeColors.darkGray};`}
    ${props => props.light && css`color: ${themeColors.mediumGray};`}
    ${props => props.error && css`color: ${themeColors.warning};`}
    ${props => props.bold && css`font-weight: 600;`}
    ${props => props.italic && css`font-style: italic; font-weight: 400;`}
    ${props => props.center && css`align-self: center;`}
`;